import { DeepPartial } from "../../interfaces/deepPartial";
import { DefaultCoverage } from "../../interfaces/dup";
import {
  CalculationModel,
  DupState,
  InsuredPerson,
  PersonalDetailsModel,
  PremiumTerms,
  SaveDupStateRequest,
} from "./DupFlow.interfaces";

export const isInsuredComplete = (insured: Partial<InsuredPerson>) =>
  Boolean(insured.dateOfBirth && insured.dateOfBirth.length === 10 && insured.firstName);

export const isCoveragesComplete = (coverage: Partial<DefaultCoverage>) => {
  const complete = Boolean(
    coverage.effectiveDate &&
      coverage.effectiveDate.length === 10 &&
      coverage.hasInsuredAmount &&
      coverage.insuranceType
  );

  if (!complete) {
    return false;
  }

  if (coverage.insuranceType === "PurchaseMoneyProduct") {
    return true;
  }

  return Boolean(coverage.paymentPeriod);
};

export const canCalculatePremium = (data: DupState) => {
  for (const insuredPerson of data.insuredPersons) {
    const insuredComplete = isInsuredComplete(insuredPerson);
    if (!insuredComplete) {
      return false;
    }
  }

  return isCoveragesComplete(data.defaultCoverage);
};

const convertToInsuredPerson = ({
  firstName,
  dateOfBirth,
  isApplied,
  isChild,
  isDefault,
  personId,
  personCoverage,
  childAsAdultPremium,
}: Partial<PersonalDetailsModel>): Partial<InsuredPerson> => ({
  firstName,
  dateOfBirth,
  isApplied,
  isChild,
  isDefault,
  personId,
  personCoverage,
  childAsAdultPremium,
});

export const convertDupStateToCalculationModel = (data: DupState): DeepPartial<CalculationModel> => ({
  defaultCoverage: data.defaultCoverage,
  paymentTerm: data.paymentTerm,
  insuredPersons: data.insuredPersons.map(convertToInsuredPerson),
});

export const convertDupStateToSaveDupStateRequest = (
  data: DupState,
  premium: PremiumTerms | null,
  oneTimePolicyCosts: string,
  applicationId: string | null
): SaveDupStateRequest => ({
  applicationId,
  firstName: data.insuredPersons[0].firstName,
  lastName: data.insuredPersons[0].lastName,
  inserts: data.insuredPersons[0].inserts,
  JSON: JSON.stringify({ ...data, premium, oneTimePolicyCosts }),
});
